import { Component } from "react";
import { withRouter } from "react-router-dom";

// scroll to top so that when we change routes we reset the viewport
class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return null;
  }
}

export default withRouter(ScrollToTop);
